/** MUI 调色板配置 — 按V1原型精确颜色 */
import type { PaletteOptions } from '@mui/material';

export const palette: PaletteOptions = {
  primary: {
    main: '#10B981',
    dark: '#059669',
    light: '#ECFDF5',
    contrastText: '#FFFFFF',
    50: '#ECFDF5',
    100: '#D1FAE5',
    200: '#A7F3D0',
    300: '#6EE7B7',
    400: '#34D399',
    500: '#10B981',
    600: '#10B981',
    700: '#059669',
    800: '#059669',
    900: '#064E3B',
  },
  secondary: {
    main: '#43A047',
    light: '#E8F5E9',
    dark: '#2E7D32',
    contrastText: '#FFFFFF',
  },
  error: {
    main: '#E53935',
    light: '#FFEBEE',
    dark: '#C62828',
    contrastText: '#FFFFFF',
  },
  warning: {
    main: '#FB8C00',
    light: '#FFF3E0',
    dark: '#E65100',
    contrastText: '#FFFFFF',
  },
  success: {
    main: '#43A047',
    light: '#E8F5E9',
    dark: '#2E7D32',
    contrastText: '#FFFFFF',
  },
  info: {
    main: '#00ACC1',
    light: '#E0F7FA',
    dark: '#00838F',
    contrastText: '#FFFFFF',
  },
  grey: {
    50: '#F8F9FB',
    100: '#F0F2F5',
    200: '#E8EAED',
    300: '#DADCE0',
    400: '#BDC1C6',
    500: '#9E9E9E',
    600: '#80868B',
    700: '#616161',
    800: '#3C4043',
    900: '#212121',
  },
  background: {
    default: '#F5F7FA',
    paper: '#FFFFFF',
  },
  text: {
    primary: '#212121',
    secondary: '#616161',
    disabled: '#9E9E9E',
  },
  divider: '#E8EAED',
};
